module.exports = __webpack_public_path__ + "files/3d9e2796677ad4c13db503824ab094bc.svg";